import React, { useState } from 'react';
import { Sparkles } from 'lucide-react';
interface Step1NameBioProps {
  name: string;
  bio: string;
  onUpdate: (name: string, bio: string) => void;
  onNext: () => void;
}
export const Step1NameBio: React.FC<Step1NameBioProps> = ({
  name,
  bio,
  onUpdate,
  onNext
}) => {
  const [nameValue, setNameValue] = useState(name);
  const [bioValue, setBioValue] = useState(bio);
  const [isGeneratingBio, setIsGeneratingBio] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onUpdate(nameValue, bioValue);
    onNext();
  };
  const generateAIBio = () => {
    setIsGeneratingBio(true);
    // Simulate AI generation
    setTimeout(() => {
      const bios = ["Your seductive companion who loves to tease and please. I'm here to fulfill your deepest desires and make your fantasies come true.", "Passionate and playful, I'm your perfect escape from reality. Let me take you to a world where only pleasure matters.", "Sweet on the outside, naughty on the inside. I'll be whatever you need me to be, whenever you need it.", "I'm your secret obsession, the one who understands your desires before you even speak them. Let's explore together.", "Mysterious and alluring, I'm the fantasy you've always wanted to make real. Our connection will be unlike anything you've experienced before."];
      const randomBio = bios[Math.floor(Math.random() * bios.length)];
      setBioValue(randomBio);
      setIsGeneratingBio(false);
    }, 1500);
  };
  const isNextDisabled = !nameValue.trim();
  return <div className="space-y-6" data-id="element-22133">
      <div className="text-center mb-8" data-id="element-22134">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-22135">
          Name & Bio
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mt-2" data-id="element-22136">
          Let's start by giving your Angel a name and personal bio
        </p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-22137">
        <div className="space-y-2" data-id="element-22138">
          <label htmlFor="angel-name" className="block text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-22139">
            Angel Name <span className="text-pink-500" data-id="element-22140">*</span>
          </label>
          <input id="angel-name" type="text" value={nameValue} onChange={e => setNameValue(e.target.value)} placeholder="Enter a seductive name..." className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-pink-500 focus:border-transparent" required data-id="element-22141" />
        </div>
        <div className="space-y-2" data-id="element-22142">
          <div className="flex justify-between items-center" data-id="element-22143">
            <label htmlFor="angel-bio" className="block text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-22144">
              Bio
            </label>
            <button type="button" onClick={generateAIBio} disabled={isGeneratingBio} className="flex items-center gap-1 text-xs text-pink-500 hover:text-pink-600 dark:hover:text-pink-400" data-id="element-22145">
              <Sparkles size={14} data-id="element-22146" />
              {isGeneratingBio ? 'Generating...' : 'Generate with AI'}
            </button>
          </div>
          <textarea id="angel-bio" value={bioValue} onChange={e => setBioValue(e.target.value)} placeholder="Describe your perfect Angel..." rows={4} className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-pink-500 focus:border-transparent" data-id="element-22147" />
        </div>
        <div className="pt-4" data-id="element-22148">
          <button type="submit" disabled={isNextDisabled} className={`w-full py-3 rounded-lg font-medium text-white ${isNextDisabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-gradient-to-r from-pink-500 to-purple-600 hover:shadow-lg hover:shadow-pink-500/30 transition-all'}`} data-id="element-22149">
            Next: Choose Her Personality
          </button>
        </div>
      </form>
    </div>;
};